import { IconAlertCircle } from '@tabler/icons-react';
import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type IDangerButtonProps = IBasicButtonProps;

const DefaultProps: Partial<IDangerButtonProps> = {
  variant: 'filled',
  color: 'red.9',
  rightSection: <IconAlertCircle />,
};

/** @registry Filled dark-red button with a warning icon for destructive confirmations; default label "Confirm". */
export const DangerButton = React.forwardRef<
  HTMLButtonElement,
  IDangerButtonProps
>(({ children = 'Confirm', ...props }, ref) => {
  return (
    <BasicButton {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicButton>
  );
});
DangerButton.displayName = 'DangerButton';
